import { Record } from 'immutable'

export interface IBrokeragePipelineProgress {
  readonly completedCriticalDates: number
  readonly hasBuyerLender: boolean
  readonly hasBuyers: boolean
  readonly hasBuyersTitleCompany: boolean
  readonly hasClosingDate: boolean
  readonly hasEarnestMoney: boolean
  readonly hasEarnestMoneyLocation: boolean
  readonly hasEffectiveDate: boolean
  readonly hasListingAgents: boolean
  readonly hasSalesPrice: boolean
  readonly hasSellerMortage: boolean
  readonly hasSellers: boolean
  readonly hasSellersTitleCompany: boolean
  readonly hasSellingAgents: boolean
  readonly percentageComplete: number
  readonly totalCriticalDates: number
}

const BrokeragePipelineProgressRecord = Record({
  completedCriticalDates: 0,
  hasBuyerLender: false,
  hasBuyers: false,
  hasBuyersTitleCompany: false,
  hasClosingDate: false,
  hasEarnestMoney: false,
  hasEarnestMoneyLocation: false,
  hasEffectiveDate: false,
  hasListingAgents: false,
  hasSalesPrice: false,
  hasSellerMortage: false,
  hasSellers: false,
  hasSellersTitleCompany: false,
  hasSellingAgents: false,
  percentageComplete: 0,
  totalCriticalDates: 0,
})

export class BrokeragePipelineProgress extends BrokeragePipelineProgressRecord
  implements IBrokeragePipelineProgress {
  public static fromJS(initialState?: Partial<IBrokeragePipelineProgress>) {
    return new BrokeragePipelineProgress(initialState)
  }

  public readonly completedCriticalDates: number
  public readonly hasBuyerLender: boolean
  public readonly hasBuyers: boolean
  public readonly hasBuyersTitleCompany: boolean
  public readonly hasClosingDate: boolean
  public readonly hasEarnestMoney: boolean
  public readonly hasEarnestMoneyLocation: boolean
  public readonly hasEffectiveDate: boolean
  public readonly hasListingAgents: boolean
  public readonly hasSalesPrice: boolean
  public readonly hasSellerMortage: boolean
  public readonly hasSellers: boolean
  public readonly hasSellersTitleCompany: boolean
  public readonly hasSellingAgents: boolean
  public readonly percentageComplete: number
  public readonly totalCriticalDates: number

  constructor(props?: Partial<BrokeragePipelineProgress>) {
    props ? super(props) : super()
  }
}
